export const ARR_REFRESH_INTERVAL_MS = 300000;

export function formatARR(value) {
  return `$${Number(value || 0).toLocaleString()}`;
}

export function getStoredArrPeriod() {
  const now = new Date();
  return {
    month: localStorage.getItem("selectedMonth") || String(now.getMonth() + 1).padStart(2, "0"),
    year: localStorage.getItem("selectedYear") || String(now.getFullYear())
  };
}
